// extracted by mini-css-extract-plugin
export default {"wrapper":"content-box_wrapper__yT9dy","title":"content-box_title__eeKHQ","info":"content-box_info__CBCLO"};